<section
    class="ai-draft relative flex h-full w-full flex-col items-center justify-center overflow-y-auto px-6 py-10"
    role="status" aria-busy="true" aria-labelledby="ai-draft-title">

    <div class="ai-draft-glow" aria-hidden="true"></div>
    <div class="ai-draft-glow ai-draft-glow--late" aria-hidden="true"></div>

    <div class="ai-core mb-8" aria-hidden="true">
        <span class="ai-ring ai-ring--outer"></span>
        <span class="ai-ring ai-ring--mid"></span>
        <span class="ai-ring ai-ring--inner"></span>
        <span class="ai-orbit">
            @for (spark of sparkles; track spark) {
            <span class="ai-spark"></span>
            }
        </span>
        <div
            class="ai-core-icon grid size-20 place-items-center rounded-full bg-gradient-to-br from-brand-studio-dark to-brand-studio text-white shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                    d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
            </svg>
        </div>
    </div>

    <h2 id="ai-draft-title" class="ai-title mb-3 text-center font-heading text-3xl font-bold sm:text-4xl">
        {{ heading() }}
    </h2>
    <p class="ai-status m-0 mb-8 text-center text-sm font-medium text-brand-studio" aria-live="polite"
        aria-atomic="true">{{ statusLine() }}</p>

    <div class="ai-log relative w-full max-w-2xl text-left">
        <bb-ai-thoughts-scroll [thoughts]="thoughts()" [isCompiling]="isCompiling()"
            [compilingLabel]="compilingLabel()" [showStatus]="false" />
    </div>
</section>
